import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { containerPreviewCompact } from '../ResourcePreviewGrid/cssPreviewContainer.js';
import { useResourcePreviewUiConfigContext } from '../resourcePreviewUiConfigContext.js';
import { useState } from 'react';
import { styled, css } from 'styled-components';
import { cssVar } from '@fabric-app/ui/theme/variables';
import Skeleton from '@fabric-app/ui/components/Skeleton';
import { newArrayLength } from '@fabric-app/utils/array';
import { randomIntFromInterval } from '@fabric-app/utils/random';
import { motion } from 'framer-motion';
import { framerAnimationFade } from '@fabric-app/ui/constants/framerAnimations';
import { Flex } from '@fabric-app/ui/components/Flex';
import { PreviewGridContainer } from '../ResourcePreviewGrid/components/PreviewContainer.js';
import { DESKTOP_CARD_HEIGHT, DESKTOP_CARD_WIDTH } from '@fabric-app/ui/theme/resourcePreviewConstants';
import { useResourceListPreferencesContextUnsafe } from '../../ResourceList/contexts/resourceListContextPreferences.js';

const ResourcePreviewSkeleton = ({ children, viewMode, className }) => {
  const uiConfigContext = useResourcePreviewUiConfigContext();
  const { minusBaseHeight, appearence } = uiConfigContext || {};
  const pref = useResourceListPreferencesContextUnsafe();
  const isAutoHeight = pref?.viewMode === "Masonry";
  const [tagSkeletons] = useState(() => newArrayLength(randomIntFromInterval(0, 2)));
  return /* @__PURE__ */ jsx(PreviewGridContainer, {
    as: motion.div,
    ...framerAnimationFade,
    className,
    children: /* @__PURE__ */ jsxs(MainContainer, {
      viewMode,
      minusBaseHeight,
      children: [
        /* @__PURE__ */ jsx(MainSkeleton, {
          viewMode,
          isAutoHeight
        }),
        viewMode !== "List" && /* @__PURE__ */ jsxs(Fragment, {
          children: [
            !appearence?.hideTitle && /* @__PURE__ */ jsx(ItemNameSkeleton, {}),
            !appearence?.hideTags && /* @__PURE__ */ jsx(TagSkeletonContainer, {
              gap: "text",
              children: tagSkeletons.map((item) => /* @__PURE__ */ jsx(TagSkeleton, {}, item))
            })
          ]
        }),
        children
      ]
    })
  });
};
const ItemNameSkeleton = styled(Skeleton).attrs((p) => {
  const [width] = useState(() => randomIntFromInterval(80, 240));
  return {
    ...p,
    randomWidth: width
  };
}).withConfig({
  displayName: "ResourcePreviewSkeleton__ItemNameSkeleton",
  componentId: "sc-9514e4be-0"
})([
  `height:34px;width:`,
  `px;border-radius:17px;`,
  `{display:none;}`
], (p) => p.randomWidth, containerPreviewCompact);
const TagSkeletonContainer = styled(Flex).attrs({
  gap: "text"
}).withConfig({
  displayName: "ResourcePreviewSkeleton__TagSkeletonContainer",
  componentId: "sc-9514e4be-1"
})([
  ``,
  `{display:none;}`
], containerPreviewCompact);
const TagSkeleton = styled(Skeleton).attrs((p) => {
  const [width] = useState(() => randomIntFromInterval(30, 80));
  return {
    ...p,
    randomWidth: width
  };
}).withConfig({
  displayName: "ResourcePreviewSkeleton__TagSkeleton",
  componentId: "sc-9514e4be-2"
})([
  `height:19px;border-radius:6px;width:`,
  `px;opacity:0.5;`,
  `{display:none;}`
], (p) => p.randomWidth, containerPreviewCompact);
const MainSkeleton = styled(Skeleton).withConfig({
  displayName: "ResourcePreviewSkeleton__MainSkeleton",
  componentId: "sc-9514e4be-3"
})([
  ``,
  ``
], (p) => {
  if (p.viewMode === "List") {
    return css([
      `height:100%;display:block;`
    ]);
  } else {
    return css([
      `height:240px;border-radius:1.25rem;`
    ]);
  }
});
const MainContainer = styled.div.withConfig({
  displayName: "ResourcePreviewSkeleton__MainContainer",
  componentId: "sc-9514e4be-4"
})([
  ``,
  ``
], (p) => {
  if (p.viewMode === "List") {
    return css([
      `border-radius:0.25rem;border:1px solid `,
      `;height:72px;overflow:hidden;`
    ], cssVar["color-border-primary"]);
  }
  return css([
    `border-radius:1.25rem;height:`,
    `px;width:`,
    `px;overflow:hidden;display:flex;flex-direction:column;align-items:center;gap:0.75rem;`,
    `{height:auto;width:auto;aspect-ratio:`,
    `;}`
  ], DESKTOP_CARD_HEIGHT - (p.minusBaseHeight || 0), DESKTOP_CARD_WIDTH, containerPreviewCompact, cssVar["preview-compact-card-aspect-ratio"]);
});

export { ResourcePreviewSkeleton };
//# sourceMappingURL=ResourcePreviewSkeleton.js.map
